import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";

function QuickLinks() {
  const links = [
    { title: "Mandatory Disclosures", link: "/mandatoryDisclosures" },
    { title: "Extension of Approval (EOA)", link: "/eoa" },
    { title: "AICTE Statutory Committees", link: "/aicteCommittees" },
    { title: "Anti-Ragging Cell & Committee", link: "/aicteCommittees#anti-ragging-committee" },
    { title: "Internal Complaint Committee (ICC)", link: "/aicteCommittees#internal-complaint-committee-(icc)" },
    { title: "Grievance Redressal Mechanism", link: "/grievance" },
    { title: "SC/ST Committee", link: "/aicteCommittees#sc-st-committee" },
    { title: "Grievances & Redressal Committee (SGRC)", link: "/aicteCommittees#grievances-&-redressal-committee-(sgrc)" },
    { title: "Establishment of Online Grievance Redressal", link: "/grievance" },
    { title: "Placement Cell Details", link: "/clubAndCell" },
    { title: "Industry Interaction Cell", link: "/clubAndCell" },
    { title: "Institution's Innovation Council (IIC)", link: "/aicteCommittees#institution's-innovation-council-(iic)" },
    { title: "Students and Faculty Insurance", link: "/insurance" },
    { title: "Fee Structure", link: "/feeStructure" },
    { title: "Student Counselor Details", link: "/aicteCommittees#student-counselors-committee" },
    { title: "Fire Safety Certificate", link: "/mandatoryDisclosures" },
    { title: "Occupancy Certificate", link: "/mandatoryDisclosures" },
    { title: "Structural Stability Certificate", link: "/mandatoryDisclosures" },
    { title: "Barrier Free Campus (Disabled Friendly)", link: "/mandatoryDisclosures" },
    { title: "Admission Process", link: "/admissionProcess" },
    { title: "Library Resources", link: "/libraryBooks" },
    { title: "Computer Center Facilities", link: "/computerCenter" },
  ];

  return (
    <>
      <Helmet>
        <title>VBU - Quick Links (AICTE Guidelines)</title>
      </Helmet>
      <div className="PageContainer">
        <div className="Campus">
          <div id="Heading">
            <h1>Quick Links</h1>
          </div>

          <div className="Desc">
            <div className="DescParagraph" style={{ width: '100%' }}>
              <p style={{ marginBottom: '30px', color: '#5f6368' }}>
                Quick navigation to AICTE mandatory disclosures, institutional sections, and statutory compliance pages.
              </p>

              <div style={{ overflowX: 'auto' }}>
                <table style={{ 
                  width: '100%', 
                  borderCollapse: 'separate', 
                  borderSpacing: '0',
                  borderRadius: '12px', 
                  overflow: 'hidden', 
                  boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                  border: '1px solid #e8eaed'
                }}>
                  <thead>
                    <tr style={{ backgroundColor: '#0f1a41', color: 'white' }}>
                      <th style={{ padding: '20px', width: '80px', textAlign: 'center', fontWeight: '600' }}>Sl. No.</th>
                      <th style={{ padding: '20px', textAlign: 'left', fontWeight: '600' }}>Title / Topic</th>
                      <th style={{ padding: '20px', textAlign: 'center', fontWeight: '600', width: '180px' }}>Click Here</th>
                    </tr>
                  </thead>
                  <tbody>
                    {links.map((item, index) => (
                      <tr key={index} style={{ 
                        borderBottom: '1px solid #eee', 
                        backgroundColor: index % 2 === 0 ? 'white' : '#f8f9fa',
                        transition: 'background-color 0.2s ease'
                      }}
                      onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f1f3f4'}
                      onMouseOut={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? 'white' : '#f8f9fa'}
                      >
                        <td style={{ padding: '18px 20px', textAlign: 'center', color: '#5f6368', fontWeight: '500' }}>{index + 1}</td>
                        <td style={{ padding: '18px 20px', color: '#202124', fontWeight: '500' }}>{item.title}</td>
                        <td style={{ padding: '15px 20px', textAlign: 'center' }}>
                          <Link 
                            to={item.link} 
                            style={{ 
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '8px 20px',
                              backgroundColor: '#f1f4ff',
                              color: '#0f1a41', 
                              textDecoration: 'none',
                              fontWeight: '600',
                              borderRadius: '6px',
                              fontSize: '0.9rem',
                              transition: 'all 0.3s ease'
                            }}
                            onMouseOver={(e) => {
                              e.target.style.backgroundColor = '#0f1a41';
                              e.target.style.color = 'white';
                            }}
                            onMouseOut={(e) => {
                              e.target.style.backgroundColor = '#f1f4ff';
                              e.target.style.color = '#0f1a41';
                            }}
                          >
                            Visit Page <FaExternalLinkAlt size={12} />
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default QuickLinks;
